import React from "react";
import { graphql } from "gatsby";
import { Box, Card, CardContent, Chip, Typography } from "@mui/material";
import { Banner300x250 } from "../components/RectangleBanner";
import { Banner300x600 } from "../components/banners/Banner300x600";
import { adData } from "../components/TopBanner";
import { CardActionArea } from "gatsby-theme-material-ui";

const TextCard = ({ to, category, date, title }) => (
  <Card sx={{ mb: 1 }}>
    <CardActionArea to={to}>
      <CardContent sx={{ padding: "12px !important" }}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          sx={{ mb: 0.75 }}
        >
          <Chip label={category.toUpperCase()} color="primary" size="small" />
          <Box>{date}</Box>
        </Box>
        <Typography fontWeight={"bold"}>{title}</Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);

export default function LatestArticles({ data }) {
  return (
    <>
      <Typography variant="h5" fontWeight={"bold"} mb={1.5}>
        Последни вести
      </Typography>
      {data.allMarkdownRemark.nodes.map((article, index) => (
        <React.Fragment key={article.slug}>
          <TextCard
            to={article.slug}
            category={article.frontmatter.category}
            date={article.frontmatter.date}
            title={article.frontmatter.title}
          />
          {(index + 1) % 5 === 0 && (
            <Box sx={{ mb: 1 }}>
              <Banner300x250 products={adData} />
            </Box>
          )}
        </React.Fragment>
      ))}
      <Box display="flex" justifyContent={"center"}>
        <Banner300x600 products={adData} />
      </Box>
    </>
  );
}

export const sliceQuery = graphql`
  query {
    allMarkdownRemark(sort: { frontmatter: { date: DESC } }, limit: 28) {
      nodes {
        slug: gatsbyPath(
          filePath: "/{MarkdownRemark.frontmatter__category}/{MarkdownRemark.frontmatter__title}"
        )
        frontmatter {
          category
          title
          date(formatString: "DD MMMM YYYY", locale: "mk-MK")
        }
      }
    }
  }
`;
